export default __webpack_public_path__ + "static/media/expert_selling.ed2fa9e8.svg";